<ng-container *ngIf="client as c">
  <details
    #d
    class="gw-bg-background-elevation-2 gw-border-base gw-rounded-2xl gw-overflow-hidden gw-gatewee-collapsible-details"
  >
    <summary
      class="gw-flex gw-items-center gw-gap-small gw-rounded-t-2xl gw-p-medium gw-cursor-pointer gw-list-none gw-select-none gw-outline-none gw-transition-colors gw-duration-300 gw-ease-out hover:gw-bg-background-neutral-1 focus-visible:gw-ring-2 focus-visible:gw-ring-background-accent-1"
    >
      <span class="gw-flex gw-min-w-0 gw-flex-1 gw-items-center gw-gap-small">
        <gatewee-icon
          [icon]="'@phi.user'"
          class="gw-shrink-0 gw-text-text-primary"
        ></gatewee-icon>
        <span
          class="gw-truncate gw-text-sm gw-font-semibold gw-text-text-primary sm:gw-text-base"
        >
          {{ 'common.invoiceClient.title' | translate }}
        </span>
      </span>
      <span
        class="gw-flex gw-min-w-0 gw-max-w-[42%] gw-items-center gw-justify-end gw-gap-2x-small sm:gw-max-w-[55%]"
      >
        <span
          class="gw-truncate gw-text-xs gw-font-medium gw-text-text-secondary sm:gw-text-sm"
          [attr.title]="c.name"
        >
          {{ c.name }}
        </span>
        <gatewee-expand-chevron
          [expanded]="d.open"
          class="gw-inline-flex gw-shrink-0 gw-text-text-secondary"
        ></gatewee-expand-chevron>
      </span>
    </summary>
    <div class="gw-gatewee-collapsible-panel">
      <div
        class="gw-gatewee-collapsible-panel-inner gw-border-t gw-border-border-normal gw-px-medium gw-pb-medium gw-pt-medium"
      >
        <div
          class="gw-flex gw-flex-col gw-gap-medium sm:gw-flex-row sm:gw-items-stretch"
        >
          <div class="gw-flex gw-min-w-0 gw-flex-1 gw-flex-col gw-gap-2x-small">
            <h4
              class="gw-m-0 gw-break-words gw-text-xs gw-font-medium gw-leading-snug gw-text-text-primary sm:gw-text-base"
            >
              {{ c.name }}
            </h4>
            <p
              class="gw-m-0 gw-break-all gw-text-xs gw-leading-normal gw-text-text-secondary sm:gw-text-sm"
            >
              {{ c.document | document : true }}
            </p>
            <p
              *ngIf="c.isLegalPerson && c.representative?.name"
              class="gw-m-0 gw-break-words gw-text-xs gw-leading-normal gw-text-text-secondary sm:gw-text-sm"
            >
              {{
                'common.invoiceClient.representative'
                  | translate : {name: c.representative?.name ?? ''}
              }}
            </p>
          </div>
          <div
            *ngIf="c.phone"
            class="gw-flex gw-w-full gw-shrink-0 gw-flex-col gw-gap-2x-small gw-rounded-lg gw-border gw-border-border-normal gw-border-l-4 gw-bg-background-elevation-1 gw-p-small sm:gw-w-auto sm:gw-min-w-[148px] sm:gw-max-w-[42%]"
          >
            <p
              class="gw-m-0 gw-text-xs gw-font-medium gw-leading-normal gw-text-text-secondary"
            >
              {{ 'common.invoiceClient.phone' | translate }}
            </p>
            <span
              class="gw-break-all gw-text-sm gw-font-medium gw-leading-snug gw-text-text-primary"
            >
              {{ c.phone | phone }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </details>
</ng-container>
